import { render, staticRenderFns } from "./fbdatetimebox.vue?vue&type=template&id=46b89d1e&"
import script from "./fbdatetimebox.vue?vue&type=script&lang=js&"
export * from "./fbdatetimebox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports